import React, { useState } from 'react';
import BuenosAires from './BuenosAires';
import Conurbano from './Conurbano';
import './index.css';

function Mapas({onclick, localidad}) {
  const [mapa, setMapa] = useState('bue');

  const changeMapa = (e, mapa) => {
    e.preventDefault();
	  setMapa(mapa);
  }

  return (
    mapa === 'bue' ?
      <BuenosAires onchange={changeMapa} onclick={onclick} localidad={localidad} />
      :
      <Conurbano onchange={changeMapa} onclick={onclick} localidad={localidad} />
  );
}

export default Mapas;